import Utils from '../utils';

//User Dashboard Revamp
export const transactionHistoryRoute = {
  path: '/transaction-history',
  component: 'dashboard',
  componentName: 'Dashboard',
  theme: 'instaCred',
  template: 'home',
  authenticated: true,
  isIdentifyUserRoute: true,
};

export const buyWithInstacredLandingRoute = {
  path: '/buy',
  component: 'buy-with-instacred-landing',
  componentName: 'Buy With InstaCred',
  theme: 'instaCred',
  template: 'home',
  isIdentifyUserRoute: true,
};

export const loginRoute = Utils.isOrganicSite()
  ? {
      path: '/account',
      component: 'account',
      componentName: 'Account',
      theme: 'instaCred',
      template: 'account',
      isIdentifyUserRoute: true,
    }
  : {
      path: '/login',
      component: 'login',
      componentName: 'Enter Mobile',
      theme: 'instaCred',
      template: 'login',
      isIdentifyUserRoute: true,
    };

export const ntbCampaignFailurePageRoute = {
  path: '/new-origination/merchant/failure',
  component: 'ntb-campaign-failure',
  componentName: 'Ntb Campaign Failure Page',
  theme: 'instaCred',
  template: 'common',
};

export const ntbCampaignUserNotEligiblePageRoute = {
  path: '/new-origination/merchant/user-not-eligible',
  component: 'ntb-campaign-user-not-eligible',
  componentName: 'Ntb Campaign User Not Eligible Page',
  theme: 'instaCred',
  template: 'common',
};

export const campaignUserActivationPreapprovedSuccessPageRoute = {
  path: '/campaign-preapproved-user-activation-success',
  component: 'campaign-preapproved-success',
  componentName: 'Campaign Preapproved User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const ntbLenderRedirectionRoute = {
  path: '/ntb-lender-redirection',
  component: 'ntb-lender-redirection',
  componentName: 'Ntb Lender Redirection',
  theme: 'instaCred',
  template: 'neutral',
};

export const redirect = {
  path: '/redirect/',
  component: 'redirect',
  componentName: 'Redirect',
  theme: 'instaCred',
  template: 'common',
};

export const instacredHomeRoutes = [
  buyWithInstacredLandingRoute,
  loginRoute,
  transactionHistoryRoute,
  campaignUserActivationPreapprovedSuccessPageRoute,
  redirect,
  ntbCampaignUserNotEligiblePageRoute,
  ntbCampaignFailurePageRoute,
];



// WEBPACK FOOTER //
// ./components/transaction/src/alias/homeRoutes.js